import { useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { setSfxEnabled, isSfxEnabled, playSfx } from "@/lib/sfx";

export default function SfxToggle() {
  const [on, setOn] = useState(isSfxEnabled());

  const toggle = () => {
    const next = !on;
    setSfxEnabled(next);
    setOn(next);
    if (next) setTimeout(() => playSfx("click"), 20);
  };

  return (
    <button
      onClick={toggle}
      className="btn-ghost !p-2"
      aria-label={on ? "Mute sound effects" : "Unmute sound effects"}
      title={on ? "Sound effects on" : "Sound effects muted"}
      data-testid={on ? "sfx-on" : "sfx-off"}
    >
      {on ? <Volume2 className="w-4 h-4 text-[color:var(--gold)]" /> : <VolumeX className="w-4 h-4 text-slate-400" />}
    </button>
  );
}
